module.exports = __webpack_public_path__ + "img/activeaz.eb68e64e.png";